import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReactModal from 'react-modal';
import * as statusActions from '../../redux/actions/statusActions';
import * as usersActions from '../../redux/actions/usersActions';

import InputErrors from './InputErrors';

class TokenExpiredModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      serverErrors: [],
    };
  }

  handleChange = (e) => {
    const { value, name } = e.target;
    this.setState({ [name]: value });
  }

  submit = (e) => {
    const { password } = this.state;
    const { dispatchUsersActions } = this.props;

    e.preventDefault();
    this.resetErrors();
    dispatchUsersActions.refreshToken(password, this.onSuccess, this.onFail);
  }

  onSuccess = () => {
    const { dispatchStatusActions } = this.props;
    this.setState({ password: '' });
    dispatchStatusActions.tokenRefreshed();
  }

  onFail = (error) => {
    this.setState({
      serverErrors: error.response
        ? error.response.data
        : ['There was a problem connecting to the server.'],
    });
  }

  resetErrors = () => {
    this.setState({ serverErrors: [] });
  }

  render() {
    const { serverErrors, password } = this.state;
    const { visible } = this.props;

    return (
      <ReactModal
        isOpen={visible}
        className="modal modal--centered"
        overlayClassName="modal__overlay"
      >
        <div className="modal__scroll">
          <div className="text">
            <h2>
              Your Session Has Ended
            </h2>
            <p>
              Please enter your password to log back in.
            </p>
          </div>
          <form className="form form--modal">
            {serverErrors.length !== 0 && <InputErrors errors={serverErrors} />}
            <label className="form__text-label" htmlFor="input-token-password">
              Password
            </label>
            <input
              id="input-token-password"
              name="password"
              value={password}
              onChange={this.handleChange}
              type="password"
            />
            <div className="form__submit-button-wrapper">
              <button
                type="submit"
                onClick={this.submit}
                className="button"
              >
                Log In
              </button>
            </div>
          </form>
        </div>
      </ReactModal>

    );
  }
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchStatusActions: bindActionCreators(statusActions, dispatch),
    dispatchUsersActions: bindActionCreators(usersActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TokenExpiredModal);



// WEBPACK FOOTER //
// ./src/components/common/TokenExpiredModal.js